module.exports = __webpack_public_path__ + "static/specialists-slideshow-05@2x-35b999d7230c310f25ed4a40a5289c2b.jpg";